<template>
    <div class="flex flex-col gap-4">
        <div class="bg-muval-gray-1/10 mx-auto my-6 flex h-[111px] w-[111px] shrink-0 items-center rounded-xl">
            <SvgIcon name="selfy-match-icon" />
        </div>
        <h1 class="text-center text-2xl font-medium">Selfy Self Pack Containers</h1>
        <p class="text-muval-gray-1 mb-6 text-center text-sm">
            Thank you! Our team will reach out to you shortly to confirm your custom quote.
        </p>
    </div>
</template>
